var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.7109 11.9609L15.5547 7.07812C15.5156 7.03906 15.4375 7 15.3594 7C15.2422 7 15.125 7.11719 15.125 7.27344V9.5C15.125 9.85156 14.8125 10.125 14.5 10.125H9.8125C9.61719 10.125 9.5 10.2812 9.5 10.4375V13.5625C9.5 13.7578 9.61719 13.875 9.8125 13.875H14.5C14.8125 13.875 15.125 14.1875 15.125 14.5V16.7656C15.125 16.8828 15.2422 17 15.3594 17C15.4375 17 15.5156 17 15.5547 16.9609L20.7109 12.0781C20.7109 12.0781 20.75 12.0391 20.75 12L20.7109 11.9609ZM22 12C22 12.3906 21.8438 12.7422 21.5703 13.0156L16.4141 17.8594C16.1406 18.1328 15.75 18.25 15.3594 18.25C14.5391 18.25 13.875 17.5859 13.875 16.7656V15.125H9.8125C8.91406 15.125 8.25 14.4609 8.25 13.5625V10.4375C8.25 9.57812 8.91406 8.875 9.8125 8.875H13.875V7.27344C13.875 6.45312 14.5391 5.75 15.3594 5.75C15.75 5.75 16.1406 5.90625 16.4141 6.17969L21.5703 11.0234C21.8438 11.2969 22 11.6484 22 12ZM8.875 4.5H5.125C4.07031 4.5 3.25 5.35938 3.25 6.375V17.625C3.25 18.6797 4.07031 19.5 5.125 19.5H8.875C9.1875 19.5 9.5 19.8125 9.5 20.125C9.5 20.4766 9.1875 20.75 8.875 20.75H5.125C3.36719 20.75 2 19.3828 2 17.625V6.375C2 4.65625 3.36719 3.25 5.125 3.25H8.875C9.1875 3.25 9.5 3.5625 9.5 3.875C9.5 4.22656 9.1875 4.5 8.875 4.5Z",
    fill: "#181C21",
    fillOpacity: 0.56
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.c49d41d433bd36e0f4fbfc2f38849dc5.svg";
export { ForwardRef as ReactComponent };